@switch (data.layout) {
  @case (layout.LAYOUT1) {
    <app-cta-layout-1 [data]="data.data" />
  }
  @case (layout.LAYOUT2) {
    <app-cta-layout-2 [data]="data.data" />
  }
}
